import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const PasswordInput = props => {
  const { name, label, options, password, setPassword, showPassword, setShowPassword, withVisibilityToggle = false } = props;

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  if (withVisibilityToggle) {
    return (
      <TextField
        fullWidth
        required
        autoComplete="new-password"
        type={showPassword[name] ? 'text' : 'password'}
        id={name}
        name={name}
        label={label}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        InputProps={{
          endAdornment:
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword({ ...showPassword, [name]: !showPassword[name] })}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword[name] ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
        }}
        {...options}
      />
    );
  }

  return (
    <TextField
      fullWidth
      required
      autoComplete="new-password"
      type='password'
      id={name}
      name={name}
      label={label}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      {...options}
    />
  );
}

export default PasswordInput;